import { UserCircle, Sparkles, Save, Loader2 } from 'lucide-react'

import { Card, CardContent } from '@/ui/card'
import { Button } from '@/ui/button'

interface AgentPersonalityTabProps {
  roleDraft: string
  systemPromptDraft: string
  onRoleChange: (v: string) => void
  onPromptChange: (v: string) => void
  onSave: () => void
  saving: boolean
}

export function AgentPersonalityTab({
  roleDraft,
  systemPromptDraft,
  onRoleChange,
  onPromptChange,
  onSave,
  saving,
}: AgentPersonalityTabProps) {
  return (
    <div className="space-y-4">
      <Card>
        <CardContent className="p-5 space-y-5">
          <div className="flex items-center gap-2">
            <UserCircle className="w-4 h-4 text-primary" />
            <h4 className="text-sm font-semibold text-navy">Role & Identity</h4>
          </div>

          <div>
            <label className="block text-sm font-medium text-navy mb-1.5">Agent Role Title</label>
            <input
              type="text"
              value={roleDraft}
              onChange={(e) => onRoleChange(e.target.value)}
              placeholder="e.g. Customer Support Specialist"
              className="w-full px-3 py-2.5 rounded-lg border border-slate-150 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white"
            />
            <p className="text-xs text-slate-400 mt-1">This title helps the agent understand its purpose.</p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-5 space-y-5">
          <div className="flex items-center gap-2">
            <Sparkles className="w-4 h-4 text-primary" />
            <h4 className="text-sm font-semibold text-navy">Personality & Instructions</h4>
          </div>

          <div>
            <label className="block text-sm font-medium text-navy mb-1.5">System Prompt</label>
            <textarea
              value={systemPromptDraft}
              onChange={(e) => onPromptChange(e.target.value)}
              rows={12}
              placeholder={`You are a helpful assistant for UBSafety, a Canadian workplace safety training company.\n\nYour job is to...`}
              className="w-full px-3 py-2.5 rounded-lg border border-slate-150 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none bg-white"
            />
            <p className="text-xs text-slate-400 mt-1.5">
              This is the core instruction set that defines how the agent thinks, speaks, and behaves.
              Be specific about tone, rules, and tools it can use.
            </p>
          </div>

          <div className="flex items-center justify-between pt-2">
            <p className="text-xs text-slate-400">
              Changes apply immediately to future agent actions.
            </p>
            <Button
              onClick={onSave}
              disabled={saving}
              className="bg-primary hover:bg-primary-dark text-white"
            >
              {saving ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : <Save className="w-4 h-4 mr-1.5" />}
              Save Personality
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
